import BaseListagem from "components/BaseListagem";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Local from "model/patrimonio/Local";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import MovimentoPatrimonioService from "service/patrimonio/MovimentoPatrimonioService";
import { converterDataHora } from "utils/convert";
import { dateFilterTemplate, DateMatchModeOptions, filterApplyTemplate, IdMatchModeOptions, ListMatchModeOptions, ProdutoFilterTemplate, statusFilterTemplate, TextMatchModeOptions } from "utils/filterUtils";

const movimentoPatrimonioService = new MovimentoPatrimonioService();

export default function MovimentoPatrimonioListagem() {
    const [locais, setLocais] = useState<Local[]>([]);
    const [pessoas, setPessoas] = useState<Pessoa[]>([]);
    const [produtos, setProdutos] = useState<Produto[]>([]);

    useEffect(() => {
        movimentoPatrimonioService.locais().then(lista => {
            setLocais(lista);
        }).catch(err => {
            console.log(err)
        });
        movimentoPatrimonioService.pessoas().then(lista => {
            setPessoas(lista);
        }).catch(err => {
            console.log(err)
        });
        movimentoPatrimonioService.produtos().then(lista => {
            setProdutos(lista);
        }).catch(err => {
            console.log(err)
        })
    },[]);

    const defaultFilters: DataTableFilterMeta = {
        dataMovimento: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        tipo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        patrimonio: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        localOrigem: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        localDestino: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        produto: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        pessoaEmprestada: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const localFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={locais} 
            onChange={(e) => options.filterCallback(e.value)} 
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const pessoaFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={pessoas} 
            onChange={(e) => options.filterCallback(e.value)} 
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    return (

        <BaseListagem ordenacao="dataMovimento,DESC" service={movimentoPatrimonioService} urlService="/movimentoPatrimonio" 
        tituloPagina={'Movimentos de Patrimônio'} defaultFilters={defaultFilters} showClearFilterButton nome="movimentoPatrimonio" 
        showNewButton={false} showEditButton={false} showRemoveButton={false} >
            <Column field="dataMovimento" body={(rowData) => rowData.dataMovimento ? converterDataHora(rowData.dataMovimento) : ""} header="Data Movimento" style={{ width: '10em' }}
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={DateMatchModeOptions} headerStyle={{ width: "10%" }}
                filterApply={filterApplyTemplate} filterElement={dateFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />
            <Column field="tipo" header="Tipo Movimento" filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={ListMatchModeOptions} body={(rowData)=>movimentoPatrimonioService.getTipo(rowData.tipo)} filterApply={filterApplyTemplate} 
                headerStyle={{ width: "10%" }} filterElement={(options) => statusFilterTemplate(options, movimentoPatrimonioService.getListaTipoFilter())}/>
            <Column field="patrimonio.codigo" header="Patrimônio" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterField="patrimonio"
                headerStyle={{ width: "10%" }} />
            <Column field="patrimonio.produto.nome" header="Produto" filter showFilterOperator={false} showAddButton={false} 
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => <ProdutoFilterTemplate options={options} opcoes={produtos} />} filterField="produto"
                headerStyle={{ width: "15%" }} />
            <Column field="localOrigem.nome" header="Local Origem" filter showFilterOperator={false} showAddButton={false} 
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={localFilterTemplate} filterField="localOrigem"
                headerStyle={{ width: "15%" }} />
            <Column field="localDestino.nome" header="Local Destino" filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={localFilterTemplate} filterField="localDestino"
                headerStyle={{ width: "15%" }} />
            <Column field="pessoaEmprestada.nome" header="Pessoa Emprestada" filter showFilterOperator={false} showAddButton={false} filterField="pessoaEmprestada" filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={pessoaFilterTemplate}
                headerStyle={{ width: "15%" }} />
        </BaseListagem>
    )
}